import React from 'react'
import { StyleSheet } from 'react-native';
import { useDispatch } from 'src/state/redux'
import { DNAButton, DNAModal, DNAText, luxColors } from '@alucio/lux-ui'
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal'

export const styles = StyleSheet.create({
  body: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    width: 560,
  },
  header: {
    paddingLeft: 24,
    paddingRight: 16,
    paddingBottom: 16,
    width: 560,
  },
});

const TrainingEventConfirmationModal = () => {
  const dispatch = useDispatch()

  const closeModal = () => dispatch(DNAModalActions.closeModal())
  const toggleModal = () => dispatch(DNAModalActions.toggleModal())

  const onDiscardChanges = () => {
    closeModal()
  }

  const onContinueEdition = () => {
    toggleModal()
  }

  return (
    <DNAModal>
      <DNAModal.Header style={styles.header} onClose={onContinueEdition}>
        <DNAText h5 testID="confirmation-modal-header-text">Unsaved changes</DNAText>
      </DNAModal.Header>
      <DNAModal.Body style={styles.body}>
        <DNAText style={{ color: luxColors.flat.primary }}>All unsaved changes will be lost</DNAText>
      </DNAModal.Body>
      <DNAModal.Confirmation>
        <DNAButton
          testID="cancel-button"
          appearance="outline"
          status="tertiary"
          onPress={onContinueEdition}
          children="Continue edition"
        />
        <DNAButton
          testID="confirmation-button"
          status="primary"
          onPress={onDiscardChanges}
          children="Discard changes"
        />
      </DNAModal.Confirmation>
    </DNAModal>
  )
}

export default TrainingEventConfirmationModal
